import { shouldShowCWQALog } from "../../../utils/shouldShowCWQALog";

interface CWPurchaseParams {
  cwPurchase: {
    transaction_id: string;
    customer_id: string;
    client_user_id: string;
    product_id: string;
    product_price: number;
    currency?: string;
  };
}

export const useCWnrcPurchase = ({ cwPurchase }: CWPurchaseParams): void => {
  const eventData = {
    transaction_id: cwPurchase.transaction_id,
    customer_id: cwPurchase.customer_id,
    cw_client_user_id: cwPurchase.client_user_id,
    payment_system: "solidgate",
    price: cwPurchase.product_price,
    currency: cwPurchase.currency ?? "USD",
    placement: "payment_form",
    product_id: cwPurchase.product_id,
    quantity: 1,
  };

  shouldShowCWQALog() && console.log(`cw_nrc_purchase event:`, eventData);
  window.gtag("event", "cw_nrc_purchase", eventData);
};